// Actions
export const SET_MAP = 'TRAVEL/MAP/SET_MAP';
export const SET_USERS = 'TRAVEL/MAP/SET_USERS';
export const SELECT_USER = 'TRAVEL/MAP/SELECT_USER';
export const CLEAR_USER = 'TRAVEL/MAP/CLEAR_USER';
export const SET_SEARCH = 'TRAVEL/MAP/SET_SEARCH';

export const setMap = (map) => ({
  type: SET_MAP,
  map
});

export const setUsers = (users) => ({
  type: SET_USERS,
  users
});

export const selectUser = (selectedUser, searchString) => ({
  type: SELECT_USER,
  selectedUser,
  searchString
});

export const clearUser = () => ({
  type: CLEAR_USER
});

export const setSearch = (searchString) => ({
  type: SET_SEARCH,
  searchString
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  map: null,
  users: [],
  selectedUser: null,
  searchString: '',
  zoom: 2
};

export default function MapReducer(
  state = DEFAULT_STATE,
  { type, map, users, selectedUser, searchString } = {}
) {
  switch (type) {
    case SET_MAP:
      return {
        ...state,
        map
      };
    case SET_USERS:
      return {
        ...state,
        users,
        selectedUser: null,
        searchString: ''
      };
    case SELECT_USER:
      return {
        ...state,
        selectedUser,
        searchString,
        zoom: 10
      };
    case CLEAR_USER:
      return {
        ...state,
        selectedUser: DEFAULT_STATE.selectedUser,
        searchString: DEFAULT_STATE.searchString,
        zoom: DEFAULT_STATE.zoom
      };
    case SET_SEARCH:
      return {
        ...state,
        selectedUser: null,
        searchString
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/travelSecurity/map/mapActions.js